import { useNavigate } from 'react-router-dom';
import { ContentContainer } from '@/components/shell/ContentContainer';
import { useAuthStore } from '@/stores/authStore';
import { STRINGS } from '@/strings/strings';

/**
 * Book flow footer.
 *
 * Sebastian ruling 2026-09-15 round 3 (superseded 2026-09-24): the
 * pre-2026-09-24 footer carried two low-frequency admin links —
 * Passwort ändern + Konto löschen. On the mobile-menu slice
 * (2026-09-24) Passwort ändern moved into the new BookHeader mobile
 * menu (+ the desktop link bar, because for book-only customers the
 * footer link was the sole entry point to `/account/password`).
 * Konto löschen stays here — a rare-use, high-consequence surface
 * that Sebastian ruled belongs low in the flow, not next to the
 * header's high-frequency links.
 *
 * Book-only customers reach /account/delete because OnboardingGuard
 * whitelists it (`ONBOARDING_BYPASS_PATHS`). Every other /account/*
 * still redirects to /onboarding/welcome for a customer who never
 * completed audio onboarding.
 */
export function BookFooter() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);

  if (user === null) return null;

  return (
    <footer className="pb-8 pt-4 desktop:pb-12">
      <ContentContainer>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs">
          <button
            type="button"
            onClick={() => navigate('/account/delete')}
            className="text-dream-navy/60 underline underline-offset-2 transition-colors hover:text-dream-navy"
          >
            {STRINGS.book.footer.deleteAccountLink}
          </button>
        </div>
      </ContentContainer>
    </footer>
  );
}
